<template>
  <div>
    <p v-if="success" class="success--text text-center">
      An email has been sent to the address provided. Please check your inbox
      and follow the instructions to reset your password.
    </p>

    <v-form v-else ref="resetPassForm" v-model="valid">
      <v-text-field
        v-model="email"
        prepend-icon="mdi-email"
        name="email"
        label="Email"
        type="email"
        :rules="emailRules"
        required
        @input="errorText = ''"
      />
      <p
        :style="{ visibility: errorText ? 'visible' : 'hidden' }"
        class="text-center error--text"
      >
        {{ errorText }}
      </p>

      <v-btn
        block
        color="primary"
        :disabled="!valid"
        :loading="loading"
        @click="submitForm"
      >
        Submit
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import firebase from "@/firebase";
const functions = firebase.functions("europe-west2");
const sendResetPassEmail = functions.httpsCallable("emails-sendResetPassEmail");

export default {
  data() {
    return {
      email: "",
      emailRules: [
        v => !!v || "The email field cannot be empty",
        v => /.+@.+/.test(v) || "The email address is not valid"
      ],
      valid: false,
      errorText: "",
      success: false,
      loading: false
    };
  },
  methods: {
    async submitForm() {
      this.success = false;

      if (this.$refs.resetPassForm.validate()) {
        this.loading = true;

        try {
          await sendResetPassEmail({ email: this.email });
          this.success = true;
        } catch (e) {
          if (e.code == "auth/user-not-found") {
            this.errorText =
              "There is no user corresponding to this email address. Please try again or request access if you do not have an account.";
          } else {
            this.errorText =
              "There was an error processing your request. Please make sure you have completed your email correctly and try again.";
          }
        }

        this.loading = false;
      }
    }
  }
};
</script>
